import * as Sentry from '@sentry/gatsby';

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [process.env.GATSBY_ELASTICSEARCH_URL]
      // Opcional: Si quieres capturar body de req/res, con listar las urls en networkDetailAllowUrls es suficiente.
    }),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
  ],
  // Enable sending logs to Sentry
  enableLogs: true,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Permite que Sentry recolecte el body de los requests cuando hay un evento de error (útil para eventos puros)
  maxRequestBodySize: 'always',
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost']
});
